import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/ui-config/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.UI_CONFIG, app: APP_PATHS.ASSETS }) ||
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.UI_CONFIG, app: APP_PATHS.ASSETS, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
